export default "__VITE_ASSET__OTmEzrWV__"